export enum PopUpActionType {
  Informative,
  GameRedirection
}
